// FB04: Allow parent menu items with dropdowns to navigate to their href.
// Fires on pointerdown (before click) so Horizon's mega-menu handlers can't
// intercept. Also runs on click as a fallback for touch/keyboard.
(function(){
  var navigating = false;
  function target(t){
    return t instanceof Element ? t.closest('a.menu-list__link[aria-haspopup="true"]') : null;
  }
  function href(link){
    var h = link.getAttribute('href');
    return (h && h !== '#' && h !== '' && h !== '/collections') ? h : null;
  }
  function tryNavigate(link){
    if (navigating) return;
    var h = href(link);
    if (!h) return;
    navigating = true;
    window.location.href = h;
  }
  document.addEventListener('pointerdown', function(e){
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = target(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // Small delay so the user's finger lifts before we navigate (avoids double-trigger).
    setTimeout(function(){ tryNavigate(link); }, 0);
  }, true);
  document.addEventListener('mousedown', function(e){
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = target(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', function(e){
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = target(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    tryNavigate(link);
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter') return;
    var link = target(e.target);
    if (!link) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    tryNavigate(link);
  }, true);
})();
